var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabItem",style:(_vm.computeStyle),on:{"click":function($event){return _vm.changeInventory(_vm.index)}}},[_c('p',[_vm._v(_vm._s(_vm.storageLocation.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }